import { Container, Graphics, Sprite } from "@inlet/react-pixi/animated";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ProgressBar from "../../baseComponents/ProgressBar";
import rasterizeSVG from "../../utils/rasterizeSVG";
import doc_vacio from "../../assets/games/AccountBank/docVacio";
import rfc from "../../assets/games/AccountBank/rfc";
import erro1 from "../../assets/games/formGame/erro1";
import logo from "../../assets/games/formGame/erro2";
import erro3 from "../../assets/games/formGame/erro3";
import textoDoc from "../../assets/games/AccountBank/texto";
import CURP from "../../assets/games/AccountBank/curp";
import datos from "../../assets/games/AccountBank/datos";
import saldo from "../../assets/games/AccountBank/saldo";
import fechaDoc from "../../assets/games/AccountBank/fecha";
import GameDialog from "../../baseComponents/GameContainer/components/GameDialog";
import gameOk from "../../assets/games/AccountBank/_0002_listo.png";
import gameWrong from "../../assets/games/AccountBank/_0001_ohno.png";

export default function Index({ visible, close }) {
  const Animated = () => {
    const scale = window.innerWidth / 1536;
    const [message, setMessage] = useState({ status: false, visible: false });
    const [currentTime, setCurrentTime] = useState(0);
    const [selected, setSelected] = useState(-1);
    const [mousePosition, setMousePosition] = useState([0, 0]);
    const TIME_LIMIT = 20;
    const placed = useRef(0);

    const [draggables, setDraggables] = useState([
      {
        index: 0,
        initPos: [-400, 0],
        finalPos: [80, -100],
        state: false,
        isDragging: false,
      },
      {
        index: 1,
        initPos: [400, 0],
        finalPos: [400, 0],
        state: false,
        isDragging: false,
      },
      {
        index: 2,
        initPos: [-380, -80],
        finalPos: [-105, -195],
        state: false,
        isDragging: false,
      },
      {
        index: 3,
        initPos: [-270, 0],
        finalPos: [-270, 0],
        state: false,
        isDragging: false,
      },
      {
        index: 4,
        initPos: [270, 0],
        finalPos: [80, -145],
        state: false,
        isDragging: false,
      },
      {
        index: 5,
        initPos: [350, -200],
        finalPos: [350, -200],
        state: false,
        isDragging: false,
      },
      {
        index: 6,
        initPos: [-360, -180],
        finalPos: [0, 140],
        state: false,
        isDragging: false,
      },
      {
        index: 7,
        initPos: [-350, 150],
        finalPos: [-78, -63],
        state: false,
        isDragging: false,
      },
      {
        index: 8,
        initPos: [350, -120],
        finalPos: [0, 38],
        state: false,
        isDragging: false,
      },
      {
        index: 9,
        initPos: [350, 120],
        finalPos: [-70, -147],
        state: false,
        isDragging: false,
      },
    ]);

    const container = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(
        -window.innerWidth / 2 / scale,
        -window.innerHeight / 2 / scale,
        window.innerWidth / scale,
        window.innerHeight / scale
      );
      g.endFill();
    });

    const curpShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(15, -163, 130, 35);
      g.endFill();
    });

    const rfcShadow = useCallback((g) => {
      g.clear();
      g.beginFill(0xffffff, 0.00000001);
      //g.beginFill(0xffffff, 0.00000001);
      g.drawRect(15, -117, 130, 35);
      g.endFill();
    });

    const datosShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(-137, -120, 125, 112);
      g.endFill();
    });

    const saldoShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(-137, 25, 280, 30);
      g.endFill();
    });

    const textoDocShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(-137, 85, 280, 110);
      g.endFill();
    });

    const fechaShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(-137, -163, 130, 35);
      g.endFill();
    });

    const logoShadow = useCallback((g) => {
      g.clear();

      g.beginFill(0xffffff, 0.00000001);
      g.drawRect(-137, -210, 130, 35);
      g.endFill();
    });

    useEffect(() => {
      if (placed.current < 7) {
        if (visible) {
          updateTime();
        } else {
          setCurrentTime(0);
        }
      }
    }, [currentTime, visible]);

    const updateTime = () => {
      if (currentTime < TIME_LIMIT) {
        setTimeout(() => {
          setCurrentTime(currentTime + 1);
        }, 1000);
      } else {
        setMessage({ status: false, visible: true });
      }
    };

    const handleMouse = (e) => {
      setMousePosition([
        (e.data.global.x - window.innerWidth / 2) / scale,
        (e.data.global.y - window.innerHeight / 2) / scale,
      ]);
    };

    const handleMouseDown = (i) => {
      draggables[i].isDragging = true;
      setDraggables([...draggables]);
      setSelected(i);
    };

    const placeDraggable = (i) => {
      if (selected + 1 && i === selected) {
        draggables[selected].isDragging = false;
        draggables[selected].state = true;
        setDraggables([...draggables]);
        setSelected(-1);
        placed.current++;
        if (placed.current === 7) {
          setTimeout(() => {
            setMessage({ status: true, visible: true });
          }, 500);
        }
      } else {
        handleMouseUp();
      }
    };

    const handleMouseUp = () => {
      if (selected + 1) {
        draggables[selected].isDragging = false;
        setDraggables([...draggables]);
        setSelected(-1);
      }
    };

    const closeDialog = () => {
      if (message.status) {
        close(4);
      } else {
        setSelected(-1);
        setDraggables([
          ...draggables.map((e) => {
            e.state = false;
            e.isDragging = false;
            return e;
          }),
        ]);
        placed.current = 0;
        close(Math.round(Math.random() * 3.5));
        setTimeout(() => {
          message.visible = false;
          setMessage({ ...message });
        }, 1000);
      }
    };

    return (
      <>
        <Container
          scale={message.visible ? 0 : 1}
          alpha={message.visible ? 0 : 1}
          pivot={[-window.innerWidth / 2, -window.innerHeight / 1.8]}
          interactive
        >
          <Sprite image={rasterizeSVG(doc_vacio, [450, 450])} anchor={0.5} />

          <Graphics
            draw={container}
            interactive
            mousemove={handleMouse}
            mouseup={handleMouseUp}
          />

          <Graphics
            draw={textoDocShadow}
            interactive
            mouseup={() => placeDraggable(6)}
          />
          <Graphics
            draw={saldoShadow}
            interactive
            mouseup={() => placeDraggable(8)}
          />
          <Graphics
            draw={datosShadow}
            interactive
            mouseup={() => placeDraggable(7)}
          />

          <Graphics
            draw={fechaShadow}
            interactive
            mouseup={() => placeDraggable(9)}
          />

          <Graphics
            draw={logoShadow}
            interactive
            mouseup={() => placeDraggable(2)}
          />

          <Graphics
            draw={curpShadow}
            interactive
            mouseup={() => placeDraggable(4)}
          />

          <Graphics
            draw={rfcShadow}
            interactive
            mouseup={() => placeDraggable(0)}
            zIndex={3}
          />

          <Container>
            <Sprite
              image={rasterizeSVG(rfc, [150, 265])}
              anchor={0.5}
              position={
                draggables[0].state
                  ? draggables[0].finalPos
                  : draggables[0].isDragging
                  ? [mousePosition[0], mousePosition[1] - 50 * scale]
                  : draggables[0].initPos
              }
              scale={selected === 0 && !draggables[0].state ? 1 : 0.9}
              interactive={!(selected + 1)}
              mousedown={() => handleMouseDown(0)}
            />
          </Container>

          <Sprite
            image={rasterizeSVG(erro1, [100, 100])}
            anchor={0.5}
            position={
              draggables[1].state
                ? draggables[1].finalPos
                : draggables[1].isDragging
                ? [mousePosition[0], mousePosition[1] - 50 * scale]
                : draggables[1].initPos
            }
            scale={selected === 1 && !draggables[1].state ? 1 : 0.8}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(1)}
          />
          <Sprite
            image={rasterizeSVG(logo, [100, 100])}
            anchor={0.5}
            position={
              draggables[2].state
                ? draggables[2].finalPos
                : draggables[2].isDragging
                ? [mousePosition[0], mousePosition[1] - 50 * scale]
                : draggables[2].initPos
            }
            scale={selected === 2 && !draggables[2].state ? 1 : 0.6}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(2)}
          />
          <Sprite
            image={rasterizeSVG(erro3, [100, 100])}
            anchor={0.5}
            position={
              draggables[3].state
                ? draggables[3].finalPos
                : draggables[3].isDragging
                ? [mousePosition[0], mousePosition[1] - 50 * scale]
                : draggables[3].initPos
            }
            scale={selected === 3 && !draggables[3].state ? 1 : 0.8}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(3)}
          />
          <Sprite
            image={rasterizeSVG(CURP, [150, 80])}
            anchor={0.5}
            position={
              draggables[4].state
                ? draggables[4].finalPos
                : draggables[4].isDragging
                ? [mousePosition[0], mousePosition[1] - 30 * scale]
                : draggables[4].initPos
            }
            scale={selected === 4 && !draggables[4].state ? 1 : 0.9}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(4)}
          />
          <Sprite
            image={rasterizeSVG(textoDoc, [265, 265])}
            anchor={0.5}
            position={
              draggables[6].state
                ? draggables[6].finalPos
                : draggables[6].isDragging
                ? [mousePosition[0], mousePosition[1] - 45 * scale]
                : draggables[6].initPos
            }
            scale={selected === 6 && !draggables[6].state ? 1.2 : 1.1}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(6)}
          />
          <Sprite
            image={rasterizeSVG(datos, [150, 265])}
            anchor={0.5}
            position={
              draggables[7].state
                ? draggables[7].finalPos
                : draggables[7].isDragging
                ? [mousePosition[0], mousePosition[1] - 50 * scale]
                : draggables[7].initPos
            }
            scale={selected === 7 && !draggables[7].state ? 1 : 0.85}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(7)}
          />
          <Sprite
            image={rasterizeSVG(saldo, [265, 100])}
            anchor={0.5}
            position={
              draggables[8].state
                ? draggables[8].finalPos
                : draggables[8].isDragging
                ? [mousePosition[0], mousePosition[1] - 40 * scale]
                : draggables[8].initPos
            }
            scale={selected === 8 && !draggables[8].state ? 1.2 : 1.1}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(8)}
          />
          <Sprite
            image={rasterizeSVG(fechaDoc, [198, 198])}
            anchor={0.5}
            position={
              draggables[9].state
                ? draggables[9].finalPos
                : draggables[9].isDragging
                ? [mousePosition[0], mousePosition[1] - 50 * scale]
                : draggables[9].initPos
            }
            scale={selected === 9 && !draggables[9].state ? 1 : 0.7}
            interactive={!(selected + 1)}
            mousedown={() => handleMouseDown(9)}
          />
          <ProgressBar
            value={currentTime}
            limit={TIME_LIMIT}
            x={-250}
            y={-530}
          />
        </Container>
        {message.visible && (
          <GameDialog
            image={message.status ? gameOk : gameWrong}
            button={"Continuar"}
            close={closeDialog}
            scale={message.visible ? 1 : 0}
            alpha={message.visible ? 1 : 0}
          />
        )}
      </>
    );
  };
  return <Animated />;
}
